import { useSearch } from "../../context/SearchContext";
import {
  IconWrapper,
  SearchBarContainer,
  SearchInput,
} from "./searchbar.styled";
import { Search } from "react-feather";

const Searchbar = () => {
  const { searchQuery, setSearchQuery } = useSearch();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <SearchBarContainer>
      <IconWrapper>
        <Search size="16px" />
      </IconWrapper>
      <SearchInput
        placeholder="Search"
        value={searchQuery}
        onChange={handleInputChange}
      />
    </SearchBarContainer>
  );
};

export default Searchbar;
